import React from 'react';
import { useLoaderData, Outlet, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import MainNavbar from '../components/Navbar/MainNavbar';
import ProfileHeader from '../components/ProfileHeader';
import { Helmet } from '../lib/helmetCompat';

export default function UserProfileLayout() {
  const { user: loadedProfileUser } = useLoaderData();
  const [profileUser, setProfileUser] = React.useState(loadedProfileUser);
  const { user } = useAuth()
  const { userId } = useParams()
  const isOwnProfile = user?.id === userId
  const origin = process.env.REACT_APP_CLIENT_URL || (typeof window !== 'undefined' ? window.location.origin : '')
  const profileLink = `${origin}/user/${userId}`

  React.useEffect(() => {
    setProfileUser(loadedProfileUser);
  }, [loadedProfileUser]);

  return (
    <>
      <MainNavbar />
      <Helmet>
        <title>{`${profileUser.name} ${profileUser.lastName ? profileUser.lastName : ''}`.trim()} - Motorik</title>
        <meta name="description" content={profileUser.description || 'Perfil en Motorik'} />
        <link rel="canonical" href={profileLink} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Motorik" />
        <meta property="og:locale" content="es_ES" />
        <meta property="og:title" content={`${profileUser.name} ${profileUser.lastName ? profileUser.lastName : ''}`.trim() + ' - Motorik'} />
        <meta property="og:description" content={profileUser.description || 'Perfil en Motorik'} />
        <meta property="og:image" content={'https://motorik.net/images/motorik-og-image.jpg'} />
        <meta property="og:url" content={profileLink} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={profileLink} />
        <meta name="twitter:title" content={`${profileUser.name} ${profileUser.lastName ? profileUser.lastName : ''}`.trim() + ' - Motorik'} />
        <meta name="twitter:description" content={profileUser.description || 'Perfil en Motorik'} />
        <meta name="twitter:image" content={'https://motorik.net/images/motorik-og-image.jpg'} />
      </Helmet>
      <ProfileHeader profileUser={profileUser} user={user} />
      <Outlet context={{ profileUser, setProfileUser, isOwnProfile }} />
    </>
  );
};
